import { t as translate } from "i18next";

const percentage = (subject: string): number => {
  if (subject.indexOf("90%") > 0) return 90;
  else if (subject.indexOf("95%") > 0) return 95;
  else if (subject.indexOf("99%") > 0) return 99;
  else if (subject.indexOf("100%") > 0) return 100;
  return 0;
};

/**
 * A notification as a Zenith list shows it: translated title, message subject,
 * and its date-time as the API wrote it, for formatSchemeDay or
 * formatSchemeDateTime.
 */
export const transformNotification = (
  item: { createdAt: string; [field: string]: any },
  isNew: boolean,
) => {
  return {
    id: item.id,
    name: translate(item.type?.titleTextTemplate, {
      senderName: item.relatedMessage?.sender?.isAdmin
        ? translate("common.administrators")
        : item.relatedMessage?.sender?.name,
      percentage: percentage(item.relatedMessage?.subject),
    }),
    subject: item.relatedMessage?.subject as string | undefined,
    date: item.createdAt,
    isNew,
  };
};
